import { apiSlice } from "../../app/api/apiSlice";
import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";

const notesAdapter = createEntityAdapter({})
const initialState = notesAdapter.getInitialState()

export const notesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getNotes: builder.query({
            query:() => ({
                url: '/notes',
                validateStatus: (response, result)=>{
                    return response.status === 200 && !result.isError
                },
            }),
        //     query: () => '/notes',
        // validateStatus: (response, result)=>{
        //     return response.status === 200 && !result.isError

        // },
        // keepUnusedDataFor: 5, //This was romoved as after making an edit it was shown for 5 sec and then it went to loading... and the default is 60 seconds so for this reason we have created an active subscription[ prefetch.js in the Auth folder]
        transformResponse: responseData =>{
            const loadedNotes = responseData.map(note=>{
                note.id = note._id
                return note
            })
            return notesAdapter.setAll(initialState,loadedNotes)
        },
        provideTags: (result, error, arg)=>{
            if(result?.ids){
                return [
                    {type: 'Note', id: 'LIST'},
                    ...result.ids.map(id=>({type: 'Note', id}))
                ]
            }else return [{type: 'Note', id:'LIST'}]
        }
    }),
    addNewNote: builder.mutation({
        query: initialNote =>({
            url:'/notes',
            method: 'POST',
            body: {
                ...initialNote,
            }
        }),
        invalidatesTags:[
            {type: 'Note', id: 'LIST'}
        ]
    }),
    updateNote: builder.mutation({
        query: initialNote => ({
            url:'/notes',
            method:'PATCH',
            body:{...initialNote}
        }),
        invalidatesTags: (result, error, arg) => [
            {type:'Note' , id: arg.id}
        ]
    }),
    deleteNote: builder.mutation({
        query: ({id}) =>({
            url: `/notes`,
            method: 'DELETE',
            body: {id}
        }),
        invalidatesTags: (result, error, arg) => [
            {type: 'Note', id: arg.id}
        ]
    }),
}),
})

export const {useGetNotesQuery,useAddNewNoteMutation, useUpdateNoteMutation, useDeleteNoteMutation} = notesApiSlice
export const selectNoteResult = notesApiSlice.endpoints.getNotes.select()
// creates memoized selector
const selectNotesData = createSelector(selectNoteResult, notesResult => notesResult.data)

export const {selectAll: selectAllNotes,
     selectById: selectNoteById, 
     selectIds: selectNoteIds} = notesAdapter.getSelectors(state => selectNotesData(state) ?? initialState)
